import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

// Search-params class for the gallery list-page demo. Mirrors the real
// convention (UserSearchParams.js): a plain .js class where fields are SET
// only inside initialize() — the base constructor calls it, then optionally
// loads the URL query — plus the static search-panel metadata read by
// GeneralSearchPanelFigma. (Kept .js like every real search-params class:
// TS class-field declarations either break CRA's Babel ('declare') or risk
// re-initializing fields after the base constructor ran.)
export default class DemoListSearchParams extends SearchParamsBase {
  initialize() {
    this.ShopName = '';
    this.City = '';
    this.Status = '';
    this.IsActive = '';
  }

  // TabOfDataTable's clear-all button does `new searchParamsType(); searchItem.ClearAll();`
  ClearAll() {
    this.initialize();
  }

  static title = 'Filter demo shops';
  static iconName = 'fa-solid fa-store';
  static startSearchButtonLabel = 'Search';
  static startSearchButtonIconName = 'fa-solid fa-search';
  static indexOfFirstFieldInAdvanced = 3;

  static fieldsInSearchBox = [
    { fieldName: 'ShopName', label: 'Shop name', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'City', label: 'City', className: 'col-4', type: InputTypesEnum.Text },
    {
      fieldName: 'Status',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.Select,
      options: [
        { label: 'Choose one...', value: '', disabled: true },
        { label: 'Created', value: 'Created', disabled: false },
        { label: 'Confirmed', value: 'Confirmed', disabled: false },
        { label: 'Planned', value: 'Planned', disabled: false },
        { label: 'Completed', value: 'Completed', disabled: false },
      ],
    },
    { fieldName: 'IsActive', label: 'Active', className: 'col-4', type: InputTypesEnum.EmptyYesNoSelect },
  ];
}
